module.exports = __webpack_public_path__ + "static/media/IMG_8026.0f4b9b93.jpg";